
import { Paper, Typography, Grid, Box } from '@mui/material';
import { Timer, Alarm, PieChart } from '@mui/icons-material';

export default function UserStats() {
  const stats = [
    { icon: Timer, label: 'Timer Sessions', value: '24' },
    { icon: Alarm, label: 'Focus Minutes', value: '360' },
    { icon: PieChart, label: 'Pi Score', value: '3.14' },
  ];

  return (
    <Paper sx={{ p: 3, width: '100%', mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Your Statistics
      </Typography>
      <Grid container spacing={3}>
        {stats.map(({ icon: Icon, label, value }) => (
          <Grid key={label} container xs={12} sm={4}>
            <Box sx={{ textAlign: 'center', width: '100%' }}>
              <Icon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h4">{value}</Typography>
              <Typography color="textSecondary">{label}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
